/* eslint-disable global-require */
import VuexyLogo from '@core/layouts/components/Logo.vue'
import store from '@/store/index'

export default {
  components: {
    VuexyLogo,
  },
  data() {
    return {
      downImg: require('@/assets/images/pages/error.svg'),
    }
  },
  computed: {
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.downImg = require('@/assets/images/pages/error-dark.svg')
        return this.downImg
      }
      return this.downImg
    },
  },
  created() {
    if (localStorage.getItem('authenticated')) {
      setTimeout(() => this.$router.push(`/${this.$i18n.locale}`), 3000)
    } else {
      setTimeout(() => this.$router.push(`/${this.$i18n.locale}/login`), 3000)
    }
  },
}
